import { BaseService } from '@services/BaseService';
import { OptionsViewModel, PageViewModel } from '@models/common.models';
import { RealEstateOfficeViewModel, RealEstateOfficeSearchViewModel } from '@models/RealEstateOffice';

class RealEstateOfficesService extends BaseService {
  constructor() {
    super('realEstate/offices');
  }

  public create(model: RealEstateOfficeViewModel): Promise<RealEstateOfficeViewModel> {
    return this.fetch<RealEstateOfficeViewModel>('', {
      method: 'POST',
      body: JSON.stringify(model)
    });
  }

  public get(id: number): Promise<RealEstateOfficeViewModel> {
    return this.fetch<RealEstateOfficeViewModel>(id.toString(), {
      method: 'GET'
    });
  }

  public getGroups(): Promise<OptionsViewModel[]> {
    return this.fetch<OptionsViewModel[]>('groups', {
      method: 'GET'
    });
  }

  public getStatuses(): Promise<OptionsViewModel[]> {
    return this.fetch<OptionsViewModel[]>('statuses', {
      method: 'GET'
    });
  }

  public search(
    ids?: number[],
    orderBy?: string,
    orderByDirection?: string,
    pageNumber?: number,
    pageSize?: number,
    query?: string
  ): Promise<PageViewModel<RealEstateOfficeSearchViewModel>> {
    const queryParameters = [];
    if (ids && ids.filter((i: number) => i != null).length > 0) {
      queryParameters.push(
        ids
          .filter((i: number) => i != null)
          .map((i: number) => `ids=${i}`)
          .join('&')
      );
    }
    if (orderBy) {
      queryParameters.push('orderBy='.concat(encodeURIComponent(orderBy)));
    }
    if (orderByDirection) {
      queryParameters.push('orderByDirection='.concat(encodeURIComponent(orderByDirection)));
    }
    if (pageNumber) {
      queryParameters.push('pageNumber='.concat(pageNumber.toString()));
    }
    if (pageSize) {
      queryParameters.push('pageSize='.concat(pageSize.toString()));
    }
    if (query) {
      queryParameters.push('query='.concat(encodeURIComponent(query)));
    }

    let uri = '';
    if (queryParameters.length > 0) {
      uri = uri.concat('?', queryParameters.join('&'));
    }

    return this.fetch<PageViewModel<RealEstateOfficeSearchViewModel>>(uri, {
      method: 'GET'
    });
  }

  public update(model: RealEstateOfficeViewModel): Promise<RealEstateOfficeViewModel> {
    return this.fetch<RealEstateOfficeViewModel>(model.id.toString(), {
      method: 'PUT',
      body: JSON.stringify(model)
    });
  }

  getTransactionCoordinatorsForOffice(officeId: number, typeId: number) {
    return this.fetch<OptionsViewModel[]>(`${officeId}/transaction-coordinators?type=${typeId}`, {
      method: 'get'
    });
  }
}

export const realEstateOfficesService = new RealEstateOfficesService();



// WEBPACK FOOTER //
// ./src/_services/RealEstateOfficesService.ts